import icon from '@ckeditor/ckeditor5-comments/theme/icons/add-comment.svg';
import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import { Model, addListToDropdown, createDropdown } from 'ckeditor5/src/ui';
import { Collection } from 'ckeditor5/src/utils';

export class CustomCommentButton extends Plugin {
  init() {
    const editor = this.editor;

    /* genStr() は共通化するために、ckeditor/src/ckeditor.jsへ移動し、getNewThreadId()になっています */

    const categories = editor.commentCategories;
    const items = new Collection();
    categories.forEach((category) => {
      items.add({
        type: 'button',
        model: new Model({
          withText: category.withText,
          label: category.label,
          labelStyle: category.labelStyle,
          commandName: category.commandName,
          commandParam: category.commandParam,
        }),
      });
    });

    editor.ui.componentFactory.add('customCommentButton', (locale) => {
      const dropdown = createDropdown(locale);
      addListToDropdown(dropdown, items);
      dropdown.buttonView.set({
        label: 'Comment',
        icon,
        tooltip: true,
      });

      dropdown.bind('isEnabled').to(this.editor, 'isReadOnly', (value) => !value);

      // Execute command when an item from the dropdown is selected.
      this.listenTo(dropdown, 'execute', (evt) => {
        const selection = editor.model.document.selection;
        if (selection) {
          const position = selection.getFirstPosition();
          if (position) {
            const nodeBefore = position.nodeBefore;
            if (nodeBefore && nodeBefore.is('element', 'imageInline')) {
              // もし直前のNodeが「imageInline」なら、アラートを表示して処理を終了する
              const message = editor.i18n.t(
                '画像とテキストの間に半角スペースを入れるか、コメント開始終了位置をずらしてコメントを設定してください'
              );
              alert(message);
              return;
            }
          }
        }
        // itemsのスレッドIDの接頭子のみ使いまわす
        var prefix = evt.source.commandParam.threadId.split('-');
        evt.source.commandParam.threadId = editor.utils.getNewThreadId(prefix[0]);
        editor.execute(evt.source.commandName, evt.source.commandParam);
        editor.editing.view.focus();
      });

      return dropdown;
    });
  }
}
